import { FormData, FormErrors } from '../../models/incobar/types';

export const validateIncoBarTag = (formData: FormData): FormErrors => {
  const newErrors = {
    grnNo: !formData.grnNo ? "GRN No is required" : "",
    partNo: !formData.partNo ? "Part No is required" : "",
    rack: !formData.rack ? "Rack is required" : "",
    packingQty: !formData.packingQty ? "Packing Qty is required" : "",
    noOfLabels: !formData.noOfLabels ? "No. of Labels is required" : "",
  };

  const balanceQtyNum = parseInt(formData.balanceQty) || 0;
  const noOfLabelsNum = parseInt(formData.noOfLabels) || 0;
  const packingQtyNum = parseInt(formData.packingQty) || 0;

  const totalQty = noOfLabelsNum * packingQtyNum;

  if (totalQty > balanceQtyNum) {
    newErrors.noOfLabels = "No of Labels Not More than the Balance Quantity";
  }

  return newErrors;
};

export const validateNoOfLabels = (
  noOfLabels: string,
  packingQty: string,
  balanceQty: string
): string => {
  const balanceQtyNum = parseInt(balanceQty) || 0;
  const noOfLabelsNum = parseInt(noOfLabels) || 0;
  const packingQtyNum = parseInt(packingQty) || 0;

  const totalQty = noOfLabelsNum * packingQtyNum;

  if (totalQty > balanceQtyNum) {
    return "No of Labels Not More than the Balance Quantity";
  }
  
  return "";
};

export const isFormValid = (errors: FormErrors): boolean => {
  return Object.values(errors).every((error) => error === "");
};